var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:"remixicon ri-" + _vm.name+(_vm.s?("-" + _vm.s):"")})}
var staticRenderFns = []

export { render, staticRenderFns }